import React from 'react';

import { Provider } from 'react-redux';
import { store } from '@flexo/reducers';

import * as ReactDOM from 'react-dom/client';
import ResizeObserver from 'resize-observer-polyfill';
import App from './app/app';

import { ClerkProvider } from '@clerk/clerk-react';
import { TranslationsProvider } from '@flexo/translations';
import { initPostHog, isSatellite, clerkDomain, primarySignInUrl, installChunkErrorRecovery } from '@flexo/general';

window.ResizeObserver = ResizeObserver;

// Auto-recover from chunk / dynamic-import load failures (stale deploys,
// Clerk webpack ChunkLoadError, failed dynamic imports).
installChunkErrorRecovery();

const ENV = (import.meta as unknown as { env: Record<string, string> }).env;

// Initialize PostHog early to capture pre-login errors
// Session recording is disabled until user authenticates
initPostHog('admin-kwick');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const publishableKey = ENV.VITE_APP_CLERK_PUBLISHABLE_KEY;

root.render(
  // <StrictMode>
  <ClerkProvider
    publishableKey={publishableKey}
    isSatellite={isSatellite}
    domain={isSatellite ? clerkDomain : undefined}
    signInUrl={isSatellite ? primarySignInUrl : undefined}
  >
    <Provider store={store}>
      <TranslationsProvider>
        <App />
      </TranslationsProvider>
    </Provider>
  </ClerkProvider>
  //</StrictMode> 
);
